var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprinklerSystemActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#8FB16A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4375 33.125V41.5625L54.6875 47.1875H45.3125L41.5625 41.5625V33.125H58.4375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.25 25.625H23.75C22.7141 25.625 21.875 24.7859 21.875 23.75V21.875H78.125V23.75C78.125 24.7859 77.2859 25.625 76.25 25.625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 25.625V29.375C31.25 31.4459 32.9291 33.125 35 33.125H65C67.0709 33.125 68.75 31.4459 68.75 29.375V25.625H31.25ZM55.1562 50H44.8438C44.0675 50 43.4375 49.37 43.4375 48.5938C43.4375 47.8175 44.0675 47.1875 44.8438 47.1875H55.1562C55.9325 47.1875 56.5625 47.8175 56.5625 48.5938C56.5625 49.37 55.9325 50 55.1562 50Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56.5625L47.6169 60.0922C46.5622 61.6541 47.5391 63.7925 49.5706 64.0372C49.7113 64.0541 49.8547 64.0625 50 64.0625C50.1453 64.0625 50.2888 64.0541 50.4294 64.0372C52.461 63.7925 53.4378 61.6541 52.3831 60.0922L50 56.5625Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70.625L47.6169 74.1547C46.5622 75.7166 47.5391 77.855 49.5706 78.0997C49.7113 78.1166 49.8547 78.125 50 78.125C50.1453 78.125 50.2888 78.1166 50.4294 78.0997C52.461 77.855 53.4378 75.7166 52.3831 74.1547L50 70.625ZM39.6875 53.75L35.5072 54.5609C33.6575 54.92 32.8363 57.1222 34.0991 58.7319C34.1863 58.8434 34.2819 58.9503 34.385 59.0534C34.4881 59.1566 34.596 59.2513 34.7066 59.3394C36.3163 60.6022 38.5185 59.7809 38.8775 57.9312L39.6875 53.75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 65L27.0697 65.8109C25.22 66.17 24.3988 68.3722 25.6616 69.9819C25.7488 70.0934 25.8444 70.2003 25.9475 70.3034C26.0506 70.4066 26.1585 70.5013 26.2691 70.5894C27.8788 71.8522 30.081 71.0309 30.44 69.1812L31.25 65Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3125 53.75L64.4928 54.5609C66.3425 54.92 67.1637 57.1222 65.9009 58.7319C65.8137 58.8434 65.7181 58.9503 65.615 59.0534C65.5119 59.1566 65.4041 59.2513 65.2934 59.3394C63.6837 60.6022 61.4816 59.7809 61.1225 57.9312L60.3125 53.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.75 65L72.9303 65.8109C74.78 66.17 75.6012 68.3722 74.3384 69.9819C74.2512 70.0934 74.1556 70.2003 74.0525 70.3034C73.9494 70.4066 73.8416 70.5013 73.7309 70.5894C72.1212 71.8522 69.9191 71.0309 69.56 69.1812L68.75 65Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinklerSystemActive);
export default __webpack_public_path__ + "static/media/sprinklerSystemActive.f950663b854735057bda5a5002b641e3.svg";
export { ForwardRef as ReactComponent };